// extracted by mini-css-extract-plugin
export default {"page":"K3-z","cartModal":"L3-z","checkout":"M3-z","placeholder":"N3-z","account":"O3-z"};